/**
 * @description
 * Error page that is presented when the service has an error. 
 * 
 * @author      Brian Sparling
 * @copyright   Mutara Inc. 2019-2026
 */

import { AfterViewInit, Component } from '@angular/core';
import { Router, RoutesRecognized } from '@angular/router';
import { filter, pairwise } from 'rxjs/operators';

@Component({
  selector: 'mutara-error-page',
  template: `<div class='error-background'><markdown class='error-message'>{{errorMessage}}</markdown></div>`,
  styleUrls: ['./error-page.component.scss'],
  standalone: false
})
export class ErrorPageComponent implements AfterViewInit {

  errorMessage: string = '<h2>We are experiencing issues communicating with the services<h2>';
  returnUrl: string = "/";

  constructor(
    private router: Router
  ) {
    this.router.events.pipe(
      filter((evt: any) => evt instanceof RoutesRecognized), pairwise())
      .subscribe((events: RoutesRecognized[]) => {
        this.returnUrl = events[0].urlAfterRedirects ?? '/';
      });
  }

  ngAfterViewInit(): void {
      setTimeout(() => {
        this.router.navigateByUrl(this.returnUrl);
      }, 5000);
  }
}
